import { useEffect, useState } from "react";
import styled from "styled-components";

import { DialogTitle, DialogContent, IconButton, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Dialog from "src/components/core/Dialog";
import CustomMap from "src/components/ui/Maps/CustomMaps";

import font from "src/styles/font";
import { Black, Red } from "src/styles/color";

const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${font.size.md};
  font-weight: 500;
  color: ${Black};

  span {
    font-size: ${font.size.md};
    font-weight: 500;
    color: ${Red};
  }
`;

const WrapperMapsContainer = styled.div`
  width: 100%;
  padding-top: calc(100% / (16 / 9));
  position: relative;
`;

const MapsContainer = styled.div`
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 16px;
`;

const AddressLocationDialog = ({ addressCoordinates, onClose }) => {
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
  });

  useEffect(() => {
    if (!addressCoordinates) return;

    setCoordinates({
      lat: addressCoordinates.lat,
      lng: addressCoordinates.lng,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressCoordinates]);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 800,
            borderRadius: 4,
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3 }}>
        <WrapperTitle>ตำแหน่งที่ตั้ง</WrapperTitle>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2} sx={{ py: 2 }}>
          <Grid item xs={12}>
            <WrapperMapsContainer>
              <MapsContainer>
                <CustomMap
                  markerLocation={{
                    lat: coordinates?.lat,
                    lng: coordinates?.lng,
                  }}
                  isViewOnly
                />
              </MapsContainer>
            </WrapperMapsContainer>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default AddressLocationDialog;
